import { useMemo } from 'react';
import styled from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons';
import { Pictogram, SpotSquare, SpotRectangle } from '@cbhq/cds-web/illustrations';
import '../../ui/Div/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
const pictogramComponentMap = {
  Pictogram,
  'Spot Square': SpotSquare,
  'Spot Rectangle': SpotRectangle
};
const DEFAULT_ALT_TEXT = 'Card Illustration Image';
function CardIllustrationIcon({
  icon,
  imageUrl,
  imageAlt,
  pictogram,
  pictogramStyle = 'Pictogram',
  maxWidth,
  height = 80,
  iconColor = 'foreground'
}) {
  const content = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
    if (icon) return /*#__PURE__*/jsx(Icon, {
      name: icon,
      color: iconColor,
      size: "m"
    });
    if (imageUrl) return /*#__PURE__*/jsx(StyledImage, {
      alt: imageAlt || DEFAULT_ALT_TEXT,
      src: imageUrl
    });
    if (pictogram) {
      const PictogramComponent = pictogramComponentMap[pictogramStyle];
      return /*#__PURE__*/jsx(PictogramContainer, {
        children: /*#__PURE__*/jsx(PictogramComponent, {
          name: pictogram
        })
      });
    }
  }, [icon, imageAlt, imageUrl, pictogram, pictogramStyle, iconColor]);
  return /*#__PURE__*/jsx(Div, {
    height: height,
    maxWidth: maxWidth,
    position: "relative",
    width: "100%",
    children: content
  });
}
const PictogramContainer = styled.div`
  display: contents;
  img {
    /* stylelint-disable-next-line declaration-no-important -- Requires testing before removing */
    height: 100% !important;
    width: fit-content;
  }
`;
const StyledImage = styled.img`
  width: unset;
  height: 100%;
  object-fit: contain;
  position: absolute;
`;
export { CardIllustrationIcon };
//# sourceMappingURL=CardIllustrationIcon.js.map
